export enum KingImages {
    RIGHT_BLACK_TWO = 'KING_RIGHT_BLACK_TWO',
    RIGHT_BLACK_THREE = 'KING_RIGHT_BLACK_THREE',
    LEFT_RED_BLACK_RIGHT_RED = 'KING_LEFT_RED_BLACK_RIGHT_RED',
    LEFT_RED_RIGHT_BLACK = 'KING_LEFT_RED_RIGHT_BLACK',
    LEFT_RED = 'KING_LEFT_RED',
    LEFT_HAND = 'KING_LEFT_HAND',
    LEFT_EMPTY_RIGHT_RED = 'KING_LEFT_EMPTY_RIGHT_RED',
    LEFT_DARK_GREEN = 'KING_LEFT_DARK_GREEN',
    LEFT_BLUE_RESTART = 'KING_LEFT_BLUE_RESTART',
    LEFT_BLUE = 'KING_LEFT_BLUE',
    LEFT_BLACK_RIGHT_BLACK = 'KING_LEFT_BLACK_RIGHT_BLACK',
    HANDS_UP = 'KING_HANDS_UP',
    HANDS_FORWARD = 'KING_HANDS_FORWARD',
    HANDS_DOWN = 'KING_HANDS_DOWN',
}
